<template>
  <div class="newDetails" v-if="load">
    <div class="banner">
      <img :src="banner.cover" alt />
    </div>
    <!-- 1 -->
    <div id="block-tony-content" data-block-plugin-id="system_main_block" class="block__wrapper">
      <article role="article" class="node node--type-news node--view-mode-full">
        <div
          class="row news-content content-container"
          id="news-content"
          data-mutate="szxl40-sticky"
          data-events="mutate"
        >
          <div class="columns small-12 large-8">
            <div class="news-top">
              <h1>
                <span>{{info.title}}</span>
              </h1>

              <div
                class="field field--name-field-news-published-date field--type-datetime field--label-hidden field__item"
              >{{info.create_time}}</div>
            </div>
            <div class="node__content">
              <div
                class="field field--name-field-news-body field--type-text-long field--label-hidden field__item"
              >
                <p v-html="info.brief"></p>
                <div v-html="info.content"></div>
              </div>
            </div>
          </div>
          <div class="columns small-12 large-3 more-list">
            <div class="title">
              <h4>更多动态</h4>
            </div>
            <div class="list" v-for="(item,index) in relate_list" :key="index">
              <a :href="`/activityDetails?id=${item.id}`">
                <img :src="item.cover" alt />
                <p>{{item.title}}</p>
              </a>
            </div>
          </div>
        </div>
      </article>
    </div>
    <!-- 2 -->
  </div>
</template>

<script>
import { ActivityDetails } from "@/api/index";
export default {
  components: {},
  data() {
    return {
      load: false,
      banner: null,
      info: null,
      relate_list: null,
    };
  },
  computed: {},
  watch: {},
  methods: {},
  created() {
    ActivityDetails(
      {
        id: this.$route.query.id,
      },
      (res) => {
        this.$emit("complete", true);
        if (res.code == 0) {
          this.load = true;
          this.banner = res.data.banner;
          this.info = res.data.info;
          this.relate_list = res.data.relate_list;
        }
      }
    );
  },
  mounted() {},
};
</script>
<style lang='less' scoped>
.banner {
  width: 100%;
  img {
    width: 100%;
    height: 30vw;
  }
}
.more-list {
  background: rgba(247, 247, 247, 1);
  padding: 3rem;
  .title {
    margin-bottom: 1rem;
    h4 {
      width: fit-content;
      padding-bottom: 0.6rem;
      border-bottom: 4px solid #e77500;
    }
  }
  .list {
    margin-bottom: 1.6rem;
    p {
      margin-bottom: 0;
    }
  }
  img {
    margin-bottom: 0.4rem;
  }
}
@media screen and (max-width: 40em) {
  .banner img {
    height: auto;
  }
  .news-top {
    h1 {
      margin-top: 1.25rem;
      font-size: 1.5rem;
    }
  }
  .field--name-field-news-published-date {
    padding-bottom: 0.75rem;
  }
  .news-content {
    padding-bottom: 0;
    p {
      text-align: justify;
    }
  }
  .content-container {
    padding: 0;
  }
  .more-list {
    padding: 1rem;
  }
}
@media screen and (max-width: 67em) {
  .more-list {
    img {
      max-width: 16rem;
    }
  }
}
</style>